'use strict';

angular.module('ecrd.core')
    .provider('CoreCRF', function() {
        this.$get = ['CoreEcrd', function CoreCRF(CoreEcrd) {
            return CoreEcrd.getCRF();
        }];
    });
